<!-- 新闻详情 -->
<template>
  <div class="home">
    <div class="content">
      <div class="header">
        <div class="header_left">
          <div class="Breadcrumb">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item :to="{ path: '/news/Immigration' }"
                >新闻列表</el-breadcrumb-item
              >
              <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <h1>兰乔帕迪斯｜独栋兰乔帕迪斯｜独栋兰乔帕迪斯｜独栋</h1>
        </div>
        <div class="QRcode">
          <img src="@/assets/QRcode.png" alt="" />
          <span>手机看新闻</span>
        </div>
      </div>
      <div class="time">2025-06-11 18:41</div>
      <div class="fuwenben">
        （一）
        为了提升学生的国际就业力，我们致力于培养学生的国际化职业发展能力。这包括一系列精心设计的教育活动和课程，旨在增强学生在全球舞台上的竞争力。首先，我们提供模块化课程，每年为参与试点的院校学生安排三个模块的国际就业力课程。这些课程特别强调培养学生的家国情怀、国际理解和跨文化沟通能力，帮助他们在全球化的工作环境中脱颖而出。其次，我们组织专题化讲座，每年为学生提供六场不同主题的讲座，例如“一带一路”就业新方向、数字经济、人工智能（AI）基础知识等，这些讲座旨在拓宽学生的视野，让他们了解最新的行业趋势和就业机会。此外，我们还通过软技能工作坊的形式，加强学生可迁移技能的培养，如领导力、团队协作、时间管理等，这些技能在任何职业领域都是极其宝贵的。为了让学生在实践中锻炼能力，我们还提供短期的国内外实践活动，这不仅能够开阔学生的国际视野，还能提升他们的跨文化沟通能力。最后，我们为学生提供海外研修与深造的机会，让他们有机会在国际环境中进一步提升自己的专业技能和国际就业力。
        <img src="@/assets/DetailsImg.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped lang="less">
.content {
  margin: 0 auto;
  width: 100%;
  max-width: 75rem;
}
@media (max-width: 576px) {
  .home {
    padding: 25px 15px;
  }
  .header {
    .header_left {
      .Breadcrumb {
        display: none !important;
      }
      h1 {
        width: 250px;
        font-size: 18px !important;
        line-height: normal;
        margin-top: 0 !important;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .QRcode {
      margin-top: 0 !important;
      img {
        width: 59px !important;
        height: 59px !important;
      }
      span {
        display: none;
      }
    }
  }
  .time {
    margin-top: -25px !important;
    font-size: 13px !important;
  }
  .fuwenben {
    margin-bottom: 15px !important;
  }
}
.header {
  display: flex;
  justify-content: space-between;
  .header_left {
    .Breadcrumb {
      margin-top: 30px;
      ::v-deep .el-breadcrumb__inner {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #3d3d3d;
      }
      ::v-deep .is-link {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #3d3d3d;
      }
    }
    h1 {
      margin-top: 30px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 30px;
      color: #0c1223;
    }
  }
  .QRcode {
    display: flex;
    flex-direction: column;
    margin-top: 26px;
    img {
      width: 119px;
      height: 119px;
    }
    span {
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 14px;
      color: #222222;
      text-align: center;
    }
  }
}
.time {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: rgba(12, 18, 35, 0.5);
  text-align: left;
  margin-bottom: 10px;
}
.fuwenben {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #121212;
  line-height: 31px;
  text-align: left;
  margin-bottom: 70px;
  img {
    width: 100%;
  }
}
</style>
